class PromoBanner extends HTMLElement {
  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    this.setup();
  }

  disconnectedCallback() {
    this.cleanup();
  }

setup() {
    requestAnimationFrame(() => {
        this.btn = this.querySelector("[data-popup-btn]");
        
        if (!this.btn) {
            console.warn("PromoBanner: Button [data-popup-btn] not found after AJAX load.");
            return;
        }

        this.cleanup(); 
        
        this.btn.addEventListener("click", this._onClick);
        
        console.log("PromoBanner: Event listener re-attached successfully.");
    });
}

  cleanup() {
    if (this.btn) {
      this.btn.removeEventListener("click", this._onClick);
    }
  }

_onClick(e) {
  e.preventDefault();

  if (window.siloPopupManager) {
    if (typeof window.siloPopupManager.open === "function") {
      window.siloPopupManager.open(); 
    }

    if (typeof window.siloPopupManager.skipToStep4 === "function") {
      window.siloPopupManager.skipToStep4(); 
    }
  } else {
    console.warn("siloPopupManager not found");
  }
}

}

customElements.define("promo-banner", PromoBanner);
